module.exports = __webpack_public_path__ + "static/img/14000411.c7c9786e.png";